import React from 'react'

export default function EventTypes() {
  return (
    <div>index</div>
  )
}
